module.exports = __webpack_public_path__ + "static/media/bounds.3d29b96d.svg";